import { type TFunction } from 'i18next';

import { t as translate } from '../core';

export const label = (key: string) => translate(`common.label.${key}`);
export const buttons = (t: TFunction, key: string) => t(`common.button.${key}`);
export const dialog = (t: TFunction, key: string) => t(`common.dialog.${key}`);
export const messages = (key: string) => translate(`common.messages.${key}`);
export const validations = (t: TFunction, key: string) => t(`common.validations.${key}`);
export const descriptions = (key: string) => translate(`common.descriptions.${key}`);
export const messagesKey = {
  savedSucessfully: 'savedSucessfully',
  deletedSucessfully: 'deletedSucessfully',
  error500: 'error-500'
};
